"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Define row type in table view rows, and flag to indicate whether row will re-render with animation.
 */
var RowOption = /** @class */ (function () {
    function RowOption(type, animate) {
        this._type = type;
        this._animate = animate;
    }
    Object.defineProperty(RowOption.prototype, "animate", {
        get: function () {
            return this._animate;
        },
        set: function (value) {
            this._animate = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowOption.prototype, "type", {
        get: function () {
            return this._type;
        },
        set: function (value) {
            this._type = value;
        },
        enumerable: true,
        configurable: true
    });
    return RowOption;
}());
exports.RowOption = RowOption;
//# sourceMappingURL=row-option.js.map